import { IS_PUBLIC, NO_AUTH_NEEDED } from '@/types';

const AiAssistantPage = () => import('@/ai-assistant/pages/ai-assistant.vue');
const AiAssistantSharePage = () => import('@/ai-assistant/pages/ai-assistant-share.vue');
const AiAssistantLogsPage = () => import('@/ai-assistant/pages/ai-assistant-logs.vue');
const AiAssistantLogDetailPage = () => import('@/ai-assistant/pages/ai-assistant-log-detail.vue');
const PequityResourcesPage = () => import('@/ai-assistant/pages/pequity-resources.vue');
const ProductsPage = () => import('@/ai-assistant/pages/products.vue');
const PagesPage = () => import('@/ai-assistant/pages/pages.vue');
const FeaturesPage = () => import('@/ai-assistant/pages/features.vue');

export const aiAssistantRoutes = [
  {
    path: '/assistant/:thread_id?',
    name: 'ai-assistant',
    component: AiAssistantPage,
  },
  {
    path: '/assistant/share/:message_id',
    name: 'ai-assistant-share',
    component: AiAssistantSharePage,
    meta: { [NO_AUTH_NEEDED]: true, [IS_PUBLIC]: true, layout: 'layout-empty' },
  },
  {
    path: '/assistant/logs',
    name: 'ai-assistant-logs',
    component: AiAssistantLogsPage,
  },
  {
    path: '/assistant/logs/:message_id',
    name: 'ai-assistant-log-detail',
    component: AiAssistantLogDetailPage,
  },
  {
    path: '/assistant/resources',
    name: 'pequity-resources',
    component: PequityResourcesPage,
  },
  {
    path: '/assistant/resources/products',
    name: 'products',
    component: ProductsPage,
  },
  {
    path: '/assistant/resources/pages',
    name: 'pages',
    component: PagesPage,
  },
  {
    path: '/assistant/resources/features',
    name: 'features',
    component: FeaturesPage,
  },
];
